module.exports = __webpack_public_path__ + "static/media/Recostar_logo.124bc58e.png";